import React from 'react';
import {WithTerms} from "../composers/with-terms";
import styles from './disclaimer.module.scss';
import {DisclaimerImageRequestParams} from "./disclaimer.image-request-params";
import {Image} from "../image/image";
import classNames from 'classnames';
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../app/consts/colors";

export const Disclaimer = WithTerms(({color = useThemeColor(COLORS.textSecondary), i18n}) => {
  const imgProps = {
    src: new DisclaimerImageRequestParams(color),
    className: classNames(styles.img)
  }

  const containerProps = {
    className: classNames(styles.container),
    style: {
      color
    }
  }

  return (
    <div {...containerProps}>
      <Image {...imgProps} />
      {
        i18n.WIDGET_GAMBLE_DISCLAIMER
      }
    </div>
  )
});
